module.exports = __webpack_public_path__ + "assets/0b62e2837b286c05ca8fe3b2f0a72f7c.mp3";